module.exports = __webpack_public_path__ + "img/article8.21b44e65.png";